/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'leave-groupe': {
    width: 26,
    height: 26,
    viewBox: '0 0 26 26',
    data: '<path pid="0" d="M.53 0C.176.03-.09.446.028.785V21.28a.607.607 0 0 0 .392.554l11.673 4.138c.349.123.773-.18.775-.554v-3.547h4.67a.61.61 0 0 0 .583-.59v-8.276c.007-.336-.318-.638-.648-.6a.61.61 0 0 0-.52.6v7.684h-4.085V6.502a.606.606 0 0 0-.319-.535L3.101 1.182h13.853v7.685c-.005.312.275.6.583.6.309 0 .588-.288.584-.6V.59A.61.61 0 0 0 17.537 0H.53zm.665 1.552l10.506 5.32v17.706L1.195 20.855V1.552zm18.978 6.945l3.091 1.848H13.69c-.291.015-.543.309-.529.618.014.31.292.579.584.564H23.3l-3.128 1.866a.618.618 0 0 0-.164.775c.143.25.487.36.747.24l4.952-2.881c.213-.135.258-.396.292-.591-.03-.234-.18-.447-.292-.591L20.756 7.48c-.695-.097-.902.643-.583 1.016z" _fill="#C4C4C4"/>'
  }
})
